/* Minskinn blog enhancements: reading progress, read time, table of contents, product card, FAQ accordion. */
(function () {
  'use strict';
  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  function slug(t, used) { var s = t.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 60) || 'section'; var b = s, i = 2; while (used[s]) s = b + '-' + i++; used[s] = 1; return s; }
  function money(c) { return '₹' + (c / 100).toLocaleString('en-IN', { maximumFractionDigits: 0 }); }

  ready(function () {
    var art = document.querySelector('.hdt-article-content article');
    if (!art || art.getAttribute('data-mg')) return;
    art.setAttribute('data-mg', '1');

    /* progress bar */
    var bar = document.createElement('div'); bar.className = 'mg-progress'; document.body.appendChild(bar);
    function onScroll() { var r = art.getBoundingClientRect(), h = art.offsetHeight - window.innerHeight * 0.5; var p = Math.min(1, Math.max(0, (-r.top) / Math.max(h, 1))); bar.style.width = (p * 100) + '%'; }
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();

    /* reading time */
    var words = (art.textContent || '').trim().split(/\s+/).length;
    var mins = Math.max(1, Math.round(words / 200));
    var meta = document.querySelector('.hdt-article-title ul');
    if (meta) { var li = document.createElement('li'); li.innerHTML = '<span class="mg-readtime">' + mins + ' min read</span>'; meta.appendChild(li); }

    /* FAQ -> accordion (content stays in the DOM, so SEO + FAQ schema are unaffected) */
    var h2s = Array.prototype.slice.call(art.querySelectorAll(':scope > h2'));
    var faqH = h2s.filter(function (h) { return /frequently asked|faq/i.test(h.textContent); })[0];
    var faqWrap = null;
    if (faqH) {
      var nodes = [], n = faqH.nextElementSibling;
      while (n && n.tagName !== 'H2') { nodes.push(n); n = n.nextElementSibling; }
      faqWrap = document.createElement('div'); faqWrap.className = 'mg-faq';
      faqH.parentNode.insertBefore(faqWrap, faqH); faqWrap.appendChild(faqH);
      var cur = null;
      nodes.forEach(function (el) {
        if (el.tagName === 'SCRIPT') { faqWrap.appendChild(el); return; }
        if (el.tagName === 'H3' || el.tagName === 'H4') {
          cur = document.createElement('details'); var s = document.createElement('summary'); s.textContent = el.textContent;
          var a = document.createElement('div'); a.className = 'mg-faq-a'; cur.appendChild(s); cur.appendChild(a); faqWrap.appendChild(cur); el.parentNode && el.parentNode.removeChild(el);
        } else if (cur) { cur.lastChild.appendChild(el); } else { faqWrap.appendChild(el); }
      });
      var first = faqWrap.querySelector('details'); if (first) first.open = true;
    }

    /* table of contents */
    var heads = Array.prototype.slice.call(art.querySelectorAll('h2')).filter(function (h) { return !(faqWrap && faqWrap.contains(h)) || h === faqH; });
    var used = {};
    heads.forEach(function (h) { if (!h.id) h.id = slug(h.textContent, used); else used[h.id] = 1; });
    if (heads.length >= 3) {
      var toc = document.createElement('details'); toc.className = 'mg-toc'; toc.open = window.innerWidth > 767;
      toc.innerHTML = '<summary>In this article</summary><ol>' + heads.map(function (h) { return '<li><a href="#' + h.id + '">' + h.textContent.replace(/</g, '&lt;') + '</a></li>'; }).join('') + '</ol>';
      var firstH = art.querySelector('h2'); var anchor = firstH; /* place before first h2 (after the intro) */
      if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(toc, anchor);
      var links = toc.querySelectorAll('a');
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { links.forEach(function (l) { l.classList.toggle('is-active', l.getAttribute('href') === '#' + e.target.id); }); } }); }, { rootMargin: '-20% 0px -70% 0px' });
        heads.forEach(function (h) { io.observe(h); });
      }
    }

    /* product card: first product link in the article */
    var pl = art.querySelector('a[href*="/products/"]');
    if (pl) {
      var m = pl.getAttribute('href').match(/\/products\/([^/?#]+)/);
      if (m) {
        fetch('/products/' + m[1] + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
          if (!p) return;
          function card() {
            var d = document.createElement('div'); d.className = 'mg-product';
            var img = p.featured_image ? '<img loading="lazy" src="' + p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_400x400_crop_center$1$2') + '" alt="' + (p.title || '').replace(/"/g, '&quot;') + '">' : '';
            var cmp = p.compare_at_price && p.compare_at_price > p.price ? '<s>' + money(p.compare_at_price) + '</s>' : '';
            d.innerHTML = img + '<div class="mg-product-body"><p class="mg-product-kicker">Featured in this article</p><p class="mg-product-title">' + (p.title || '').replace(/</g, '&lt;') + '</p><p class="mg-product-price">' + money(p.price) + cmp + '</p><a class="mg-btn" href="/products/' + m[1] + '">Shop now</a></div>';
            return d;
          }
          /* after the 3rd top-level paragraph (early, visible) and again before the FAQ / end */
          var ps = Array.prototype.slice.call(art.children).filter(function (e) { return e.tagName === 'P' && e.textContent.trim().length > 40; });
          var early = ps[2] || ps[ps.length - 1];
          if (early && early.parentNode) early.parentNode.insertBefore(card(), early.nextSibling);
          var late = faqWrap || null;
          if (late) late.parentNode.insertBefore(card(), late); else art.appendChild(card());
        }).catch(function () {});
      }
    }
  });
})();
